'use client';

import type { PropsWithChildren } from 'react';

import useScrollTracking from '@/app/hooks/useScrollTracking';

const Security = ({ children }: PropsWithChildren) => {
  // scroll depth tracking hook for segment analytics
  useScrollTracking();

  return <div data-cy="oura-data-protection-and-trust-page">{children}</div>;
};

export default Security;
